import { CustomerType } from '../enums';
import { LicenceCustomerState } from '../enums/licence-customer-state';

export class CustomerFilter {
    titleNumber: number;
    name: string;
    email: string;
    phone: string;
    federalId: string;
    codRegistration: string | null;
    groupIds: string;
    city: string;
    state: string;
    reviewed: boolean;
    active: boolean;
    onlyAssociated: boolean;
    type: CustomerType;
    licenceStates: LicenceCustomerState[];
    size: number;
    page: number;
    sort: string;
    order: string;
    userApp: boolean;
    onlyMarina: boolean;
    marinaCompanyId: number;
    customerProfile: string;
    hasPhoto: any;

    constructor() {
        this.size = 10;
        this.page = 0;
        this.order = 'ASC';
        this.onlyMarina = false;
        this.hasPhoto = '';
        this.codRegistration = null;
    }
}
